import { RefObject, useEffect } from 'react';

export function useAutoScrollBottom(ref: RefObject<HTMLElement>, deps: unknown[], threshold = 550) {
	useEffect(() => {
		const el = ref.current;
		if (!el) {
			return;
		}

		const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;

		const nearBottom = distanceToBottom < threshold;

		if (nearBottom) {
			el.scrollTo({
				top: el.scrollHeight,
				behavior: 'smooth',
			});
		}
	}, deps);
}
